import { render, staticRenderFns } from "./login-warning.vue?vue&type=template&id=0e3ea3c9"
import script from "./login-warning.vue?vue&type=script&lang=ts"
export * from "./login-warning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports